import React from "react";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { NavLink } from "react-router-dom";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ArticleIcon from "@mui/icons-material/Article";
import BarChartIcon from "@mui/icons-material/BarChart";
import BusinessIcon from "@mui/icons-material/Business";
import GroupIcon from "@mui/icons-material/Group";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

import { useAuth } from "../../providers/AuthProvider";
import { BRAND_BLUE, BRAND_GREEN } from "../../theme/colors";

const linkSx = {
  borderRadius: 2,
  mx: 1,
  my: 0.5,
  "& .MuiListItemText-primary": {
    color: BRAND_BLUE,
  },
  "&.active": {
    bgcolor: "action.selected",
    "& .MuiListItemText-primary": { fontWeight: 800 },
  },
};

export default function AdminSideNav() {
  const { logout } = useAuth();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <List sx={{ pt: 1, flex: 1 }}>
        <ListItemButton component={NavLink} to="/admin/create-org" sx={linkSx}>
          <ListItemIcon>
            <BusinessIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Organizations" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/org-users" sx={linkSx}>
          <ListItemIcon>
            <GroupIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/metrics" sx={linkSx}>
          <ListItemIcon>
            <BarChartIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Metrics" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/ai-credits" sx={linkSx}>
          <ListItemIcon>
            <AutoAwesomeIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="AI Credits" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/notifications" sx={linkSx}>
          <ListItemIcon>
            <NotificationsActiveRoundedIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Notifications" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/demo-leads" sx={linkSx}>
          <ListItemIcon>
            <OndemandVideoIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Demo Video Leads" />
        </ListItemButton>

        <ListItemButton component={NavLink} to="/admin/articles" sx={linkSx}>
          <ListItemIcon>
            <ArticleIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Landing Articles" />
        </ListItemButton>

      </List>

      <Divider />
      <List sx={{ pb: 1 }}>
        <ListItemButton onClick={logout} sx={linkSx}>
          <ListItemIcon>
            <LogoutIcon sx={{ color: BRAND_GREEN }} />
          </ListItemIcon>
          <ListItemText primary="Log Out" />
        </ListItemButton>
      </List>
    </Box>
  );
}
